import { render } from "./view-stock-adjustment.vue?vue&type=template&id=8520cda4&scoped=true"
import script from "./view-stock-adjustment.vue?vue&type=script&lang=js"
export * from "./view-stock-adjustment.vue?vue&type=script&lang=js"

import "./view-stock-adjustment.vue?vue&type=style&index=0&id=8520cda4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8520cda4"]])

export default __exports__